document.addEventListener('DOMContentLoaded', function () {
    if ($('.wechatQRcode').length > 0) {
        $('.qrcode').qrcode($('.wechatQRcode').data('link'));

    }
})